export const menuTypes = {
  MAIN: 'main',
  FAVORITES: 'favorites',
};

export const buildTreeMenu = (
  array,
  parent = { itemId: '0' },
  treeMenu = [],
  modules = [],
) => {
  const children = array
    .filter((child) => child.parentId === parent.itemId)
    .sort((a, b) => a.itemOrder - b.itemOrder);

  if (children.length && children.length > 0) {
    if (parent.itemId === '0') {
      children.children = children;
      // eslint-disable-next-line no-param-reassign
      treeMenu = children;
    } else {
      parent.children = children;
    }

    children.forEach((child) => {
      child.path = [];
      if (parent.itemId !== '0') {
        child.path.push(...parent.path);
      }
      child.path.push({ text: child.traduction, itemId: child.itemId });

      if (
        child.applicationId &&
        !modules.includes(child.applicationId.substr(0, 7).toLowerCase())
      ) {
        modules.push(child.applicationId.substr(0, 7).toLowerCase());
      }

      buildTreeMenu(array, child, null, modules);
    });
  }

  return { treeMenu, modules };
};
